import { IModifier } from './Modifier';
import { EAnimationModifiers } from '../../Animation/SpineWrapperEventManager';
import { getAllEventModifiers } from '../../Utils/ModifierUtils';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { GameStore } from '@GameStore/GameStore';

export class FreeGamesModifier implements IModifier {
    constructor(readonly gameStore: GameStore) {}

    public modifierCheck(name: string): boolean {
        return getAllEventModifiers(name).includes(EAnimationModifiers.FREE_GAMES);
    }

    public requirementCheck(name: string): boolean {
        const isFreeGamesMode = this.gameStore.get(EGameStoreKeys.IsFreeGamesMode);
        return isFreeGamesMode;
    }
}
